import React, {useEffect, useState} from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from "react-router-dom";
import "./_imagewithblock.scss";

function PartnersInformation({ content }) {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        setIsLoading(false);
    }, [])
    if(isLoading){
        return <div></div>;
    }
    return (
        <section className="section-gap tour-section-2">
            <Container>
                <Row className="g-4 g-xl-5 justify-content-center">
                    {Object?.values(content?.val?.items)?.map((item, index) => (
                        <Col md={6} lg={4} xxl={3}  key={index} className="text-center item-wrap">
                            <div className="item rounded-3 p-lg-4 p-3 h-100">
                                <h6 className="title mb-2">
                                    {item?.tab_section_link ? (
                                        <Link to={item?.tab_section_link} title={item?.tab_section_title} target="_blank">{item?.tab_section_title}</Link>
                                    ) : item?.tab_section_title}
                                </h6>
                                <div className="cms">
                                    <Link className="mt-0 link-wrapper"  to={`tel:${item?.tab_section_phone}`}  title={`Call us on: ${item?.tab_section_phone}`}  target="_blank">{item?.tab_section_phone}</Link>
                                    {/* <p>{item?.tab_section_phone}</p> */}
                                    {item?.tab_section_areadetails?.split("\n")?.map((line, index) => (
                                        <p key={index}>{line}</p>
                                    ))}
                                    {item?.tab_section_link ? (
                                        // <p>{item?.tab_section_link}</p>
                                        <Link className="mt-4 link-wrapper" to={item?.tab_section_link} title={`Visit us: ${item?.tab_section_link}`} target="_blank">{item?.tab_section_link}</Link>
                                    ) : ''}
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
}

export default PartnersInformation;
